import {
  ChangeEvent,
  Dispatch,
  SetStateAction,
  useMemo,
  useState
} from 'react';
import { ValidationLogic } from './useTextInput';
import useDebounce from './useDebounce';

function useSelecter(
  initVal: string,
  validationLogics: ValidationLogic[],
  delay: number,
  placeHolder?: string
): [
  string,
  (e: ChangeEvent<HTMLSelectElement>) => void,
  string | undefined,
  Dispatch<SetStateAction<string>>,
  Dispatch<SetStateAction<boolean>>
] {
  const [selected, setSelected] = useState(initVal);

  const debouncedValue = useDebounce(selected, delay);

  const [notTouched, setNotTouched] = useState(true);

  const errMsg = useMemo(() => {
    if (notTouched) {
      return '';
    }

    for (const { logic, msg } of validationLogics) {
      if (logic(debouncedValue)) {
        return msg;
      }
    }
  }, [notTouched, debouncedValue]);

  const onChangeSelected = (e: ChangeEvent<HTMLSelectElement>) => {
    const { value } = e.target;
    if (placeHolder != null && placeHolder === e.target.value) return;
    setSelected(value);
    if (notTouched) {
      setNotTouched(false);
    }
  };

  return [selected, onChangeSelected, errMsg, setSelected, setNotTouched];
}

export default useSelecter;
